import { render, staticRenderFns } from "./TheLegend.vue?vue&type=template&id=49b58bfa&scoped=true&"
import script from "./TheLegend.vue?vue&type=script&lang=js&"
export * from "./TheLegend.vue?vue&type=script&lang=js&"
import style0 from "./TheLegend.vue?vue&type=style&index=0&id=49b58bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b58bfa",
  null
  
)

export default component.exports